export default __webpack_public_path__ + "static/media/head_yellow.01b5e36a.png";